module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Medium.9f7769f5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/themes/fonts/SFProDisplay-Medium.woff
// module id = 332
// module chunks = 1